import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { HttpParams, HttpHeaders, HttpRequest, HttpResponse, HttpClient, HttpClientModule } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/aggregate-run-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
import * as ɵngcc0 from '@angular/core';
var AggregateRunStatus;
(function (AggregateRunStatus) {
    AggregateRunStatus.PENDING = 'Pending';
    AggregateRunStatus.VERIFYING = 'Verifying';
    AggregateRunStatus.VERIFICATION_COMPLETED = 'VerificationCompleted';
    AggregateRunStatus.RUNNING = 'Running';
    AggregateRunStatus.IMAGING_COMPLETED = 'ImagingCompleted';
    AggregateRunStatus.UPLOADING = 'Uploading';
    AggregateRunStatus.UPLOAD_FAILED = 'UploadFailed';
    AggregateRunStatus.COMPLETED = 'Completed';
    AggregateRunStatus.FAILED = 'Failed';
    AggregateRunStatus.TIMED_OUT = 'TimedOut';
    AggregateRunStatus.ABORTED = 'Aborted';
    AggregateRunStatus.NEEDS_ATTENTION = 'NeedsAttention';
    /**
     * @return {?}
     */
    function values() {
        return [
            AggregateRunStatus.PENDING,
            AggregateRunStatus.VERIFYING,
            AggregateRunStatus.VERIFICATION_COMPLETED,
            AggregateRunStatus.RUNNING,
            AggregateRunStatus.IMAGING_COMPLETED,
            AggregateRunStatus.UPLOADING,
            AggregateRunStatus.UPLOAD_FAILED,
            AggregateRunStatus.COMPLETED,
            AggregateRunStatus.FAILED,
            AggregateRunStatus.TIMED_OUT,
            AggregateRunStatus.ABORTED,
            AggregateRunStatus.NEEDS_ATTENTION
        ];
    }
    AggregateRunStatus.values = values;
})(AggregateRunStatus || (AggregateRunStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-configuration-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisConfigurationSortFields;
(function (AnalysisConfigurationSortFields) {
    AnalysisConfigurationSortFields.TIME_MODIFIED = 'TimeModified';
    AnalysisConfigurationSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisConfigurationSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisConfigurationSortFields.TIME_MODIFIED,
            AnalysisConfigurationSortFields.TIME_CREATED,
            AnalysisConfigurationSortFields.NAME
        ];
    }
    AnalysisConfigurationSortFields.values = values;
})(AnalysisConfigurationSortFields || (AnalysisConfigurationSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-definition-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnalysisDefinitionSortFields;
(function (AnalysisDefinitionSortFields) {
    AnalysisDefinitionSortFields.TIME_MODIFIED = 'TimeModified';
    AnalysisDefinitionSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisDefinitionSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisDefinitionSortFields.TIME_MODIFIED,
            AnalysisDefinitionSortFields.TIME_CREATED,
            AnalysisDefinitionSortFields.NAME
        ];
    }
    AnalysisDefinitionSortFields.values = values;
})(AnalysisDefinitionSortFields || (AnalysisDefinitionSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-file-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var AnalysisFileSortFields;
(function (AnalysisFileSortFields) {
    AnalysisFileSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisFileSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisFileSortFields.TIME_CREATED,
            AnalysisFileSortFields.NAME
        ];
    }
    AnalysisFileSortFields.values = values;
})(AnalysisFileSortFields || (AnalysisFileSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-run-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnalysisRunSortFields;
(function (AnalysisRunSortFields) {
    AnalysisRunSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisRunSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisRunSortFields.TIME_CREATED,
            AnalysisRunSortFields.NAME
        ];
    }
    AnalysisRunSortFields.values = values;
})(AnalysisRunSortFields || (AnalysisRunSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/analysis-version-definition-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnalysisVersionDefinitionSortFields;
(function (AnalysisVersionDefinitionSortFields) {
    AnalysisVersionDefinitionSortFields.TIME_MODIFIED = 'TimeModified';
    AnalysisVersionDefinitionSortFields.TIME_CREATED = 'TimeCreated';
    AnalysisVersionDefinitionSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            AnalysisVersionDefinitionSortFields.TIME_MODIFIED,
            AnalysisVersionDefinitionSortFields.TIME_CREATED,
            AnalysisVersionDefinitionSortFields.NAME
        ];
    }
    AnalysisVersionDefinitionSortFields.values = values;
})(AnalysisVersionDefinitionSortFields || (AnalysisVersionDefinitionSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/bead-chip-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var BeadChipSortFields;
(function (BeadChipSortFields) {
    BeadChipSortFields.TIME_CREATED = 'TimeCreated';
    BeadChipSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            BeadChipSortFields.TIME_CREATED,
            BeadChipSortFields.NAME
        ];
    }
    BeadChipSortFields.values = values;
})(BeadChipSortFields || (BeadChipSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-configurations-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListAnalysisConfigurationsIncludeFlags;
(function (ListAnalysisConfigurationsIncludeFlags) {
    ListAnalysisConfigurationsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisConfigurationsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListAnalysisConfigurationsIncludeFlags.values = values;
})(ListAnalysisConfigurationsIncludeFlags || (ListAnalysisConfigurationsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-definitions-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListAnalysisDefinitionsIncludeFlags;
(function (ListAnalysisDefinitionsIncludeFlags) {
    ListAnalysisDefinitionsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListAnalysisDefinitionsIncludeFlags.ANALYSIS_VERSIONS = 'AnalysisVersions';
    ListAnalysisDefinitionsIncludeFlags.ARCHIVED = 'Archived';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisDefinitionsIncludeFlags.TOTAL_ITEM_COUNT,
            ListAnalysisDefinitionsIncludeFlags.ANALYSIS_VERSIONS,
            ListAnalysisDefinitionsIncludeFlags.ARCHIVED
        ];
    }
    ListAnalysisDefinitionsIncludeFlags.values = values;
})(ListAnalysisDefinitionsIncludeFlags || (ListAnalysisDefinitionsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-files-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListAnalysisFilesIncludeFlags;
(function (ListAnalysisFilesIncludeFlags) {
    ListAnalysisFilesIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisFilesIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListAnalysisFilesIncludeFlags.values = values;
})(ListAnalysisFilesIncludeFlags || (ListAnalysisFilesIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-run-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListAnalysisRunIncludeFlags;
(function (ListAnalysisRunIncludeFlags) {
    ListAnalysisRunIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisRunIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListAnalysisRunIncludeFlags.values = values;
})(ListAnalysisRunIncludeFlags || (ListAnalysisRunIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-analysis-version-definitions-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListAnalysisVersionDefinitionsIncludeFlags;
(function (ListAnalysisVersionDefinitionsIncludeFlags) {
    ListAnalysisVersionDefinitionsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListAnalysisVersionDefinitionsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListAnalysisVersionDefinitionsIncludeFlags.values = values;
})(ListAnalysisVersionDefinitionsIncludeFlags || (ListAnalysisVersionDefinitionsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-bead-chips-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListBeadChipsIncludeFlags;
(function (ListBeadChipsIncludeFlags) {
    ListBeadChipsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListBeadChipsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListBeadChipsIncludeFlags.values = values;
})(ListBeadChipsIncludeFlags || (ListBeadChipsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-manifests-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListManifestsIncludeFlags;
(function (ListManifestsIncludeFlags) {
    ListManifestsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListManifestsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListManifestsIncludeFlags.values = values;
})(ListManifestsIncludeFlags || (ListManifestsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-products-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListProductsIncludeFlags;
(function (ListProductsIncludeFlags) {
    ListProductsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListProductsIncludeFlags.TOTAL_ITEM_COUNT
        ];
    }
    ListProductsIncludeFlags.values = values;
})(ListProductsIncludeFlags || (ListProductsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-runs-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListRunsIncludeFlags;
(function (ListRunsIncludeFlags) {
    ListRunsIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListRunsIncludeFlags.SAMPLE_SECTION_DATA = 'SampleSectionData';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListRunsIncludeFlags.TOTAL_ITEM_COUNT,
            ListRunsIncludeFlags.SAMPLE_SECTION_DATA
        ];
    }
    ListRunsIncludeFlags.values = values;
})(ListRunsIncludeFlags || (ListRunsIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/list-samples-include-flags.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListSamplesIncludeFlags;
(function (ListSamplesIncludeFlags) {
    ListSamplesIncludeFlags.TOTAL_ITEM_COUNT = 'TotalItemCount';
    ListSamplesIncludeFlags.SAMPLE_READY_FOR_ANALYSIS = 'SampleReadyForAnalysis';
    /**
     * @return {?}
     */
    function values() {
        return [
            ListSamplesIncludeFlags.TOTAL_ITEM_COUNT,
            ListSamplesIncludeFlags.SAMPLE_READY_FOR_ANALYSIS
        ];
    }
    ListSamplesIncludeFlags.values = values;
})(ListSamplesIncludeFlags || (ListSamplesIncludeFlags = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/manifest-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ManifestSortFields;
(function (ManifestSortFields) {
    ManifestSortFields.TIME_CREATED = 'TimeCreated';
    ManifestSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            ManifestSortFields.TIME_CREATED,
            ManifestSortFields.NAME
        ];
    }
    ManifestSortFields.values = values;
})(ManifestSortFields || (ManifestSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/product-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var ProductSortFields;
(function (ProductSortFields) {
    ProductSortFields.TIME_CREATED = 'TimeCreated';
    ProductSortFields.NAME = 'Name';
    /**
     * @return {?}
     */
    function values() {
        return [
            ProductSortFields.TIME_CREATED,
            ProductSortFields.NAME
        ];
    }
    ProductSortFields.values = values;
})(ProductSortFields || (ProductSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunSortFields;
(function (RunSortFields) {
    RunSortFields.DEFAULT = 'Default';
    RunSortFields.TIME_MODIFIED = 'TimeModified';
    RunSortFields.BEAD_CHIP_NAME = 'BeadChipName';
    RunSortFields.IMAGING_TIME_COMPLETED = 'ImagingTimeCompleted';
    RunSortFields.UPLOAD_TIME_STARTED = 'UploadTimeStarted';
    RunSortFields.UPLOAD_TIME_COMPLETED = 'UploadTimeCompleted';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunSortFields.DEFAULT,
            RunSortFields.TIME_MODIFIED,
            RunSortFields.BEAD_CHIP_NAME,
            RunSortFields.IMAGING_TIME_COMPLETED,
            RunSortFields.UPLOAD_TIME_STARTED,
            RunSortFields.UPLOAD_TIME_COMPLETED
        ];
    }
    RunSortFields.values = values;
})(RunSortFields || (RunSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-stage-progress.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunStageProgress;
(function (RunStageProgress) {
    RunStageProgress.STARTED = 'Started';
    RunStageProgress.COMPLETED = 'Completed';
    RunStageProgress.FAILED = 'Failed';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunStageProgress.STARTED,
            RunStageProgress.COMPLETED,
            RunStageProgress.FAILED
        ];
    }
    RunStageProgress.values = values;
})(RunStageProgress || (RunStageProgress = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/run-upload-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var RunUploadStatus;
(function (RunUploadStatus) {
    RunUploadStatus.NOT_STARTED = 'NotStarted';
    RunUploadStatus.UPLOADING = 'Uploading';
    RunUploadStatus.UPLOAD_COMPLETED = 'UploadCompleted';
    RunUploadStatus.UPLOAD_FAILED = 'UploadFailed';
    /**
     * @return {?}
     */
    function values() {
        return [
            RunUploadStatus.NOT_STARTED,
            RunUploadStatus.UPLOADING,
            RunUploadStatus.UPLOAD_COMPLETED,
            RunUploadStatus.UPLOAD_FAILED
        ];
    }
    RunUploadStatus.values = values;
})(RunUploadStatus || (RunUploadStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sample-section-data-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SampleSectionDataStatus;
(function (SampleSectionDataStatus) {
    SampleSectionDataStatus.PASS = 'Pass';
    SampleSectionDataStatus.FAIL = 'Fail';
    /**
     * @return {?}
     */
    function values() {
        return [
            SampleSectionDataStatus.PASS,
            SampleSectionDataStatus.FAIL
        ];
    }
    SampleSectionDataStatus.values = values;
})(SampleSectionDataStatus || (SampleSectionDataStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sample-sort-fields.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SampleSortFields;
(function (SampleSortFields) {
    SampleSortFields.TIME_MODIFIED = 'TimeModified';
    SampleSortFields.TIME_CREATED = 'TimeCreated';
    /**
     * @return {?}
     */
    function values() {
        return [
            SampleSortFields.TIME_MODIFIED,
            SampleSortFields.TIME_CREATED
        ];
    }
    SampleSortFields.values = values;
})(SampleSortFields || (SampleSortFields = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/sort-direction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var SortDirection;
(function (SortDirection) {
    SortDirection.ASC = 'Asc';
    SortDirection.DESC = 'Desc';
    /**
     * @return {?}
     */
    function values() {
        return [
            SortDirection.ASC,
            SortDirection.DESC
        ];
    }
    SortDirection.values = values;
})(SortDirection || (SortDirection = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/base-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Custom parameter codec to correctly handle the plus sign in parameter
 * values. See https://github.com/angular/angular/issues/18261
 */
class ParameterCodec {
    /**
     * @param {?} key
     * @return {?}
     */
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}
/** @type {?} */
const PARAMETER_CODEC = new ParameterCodec();
/**
 * Base class for API services
 */
class BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this._rootUrl = '';
    }
    /**
     * Returns the root url for API operations. If not set directly in this
     * service, will fallback to ApiConfiguration.rootUrl.
     * @return {?}
     */
    get rootUrl() {
        return this._rootUrl || this.config.rootUrl;
    }
    /**
     * Sets the root URL for API operations in this service.
     * @param {?} rootUrl
     * @return {?}
     */
    set rootUrl(rootUrl) {
        this._rootUrl = rootUrl;
    }
    /**
     * Creates a new `HttpParams` with the correct codec
     * @protected
     * @return {?}
     */
    newParams() {
        return new HttpParams({
            encoder: PARAMETER_CODEC
        });
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BaseService.prototype._rootUrl;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.config;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/gms-api-configuration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Global configuration for GmsApi services
 */
class GmsApiConfiguration {
    constructor() {
        this.rootUrl = 'https://integration.stratus.illumina.com';
    }
}
GmsApiConfiguration.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: GmsApiConfiguration, factory: function GmsApiConfiguration_Factory(t) { return new (t || GmsApiConfiguration)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GmsApiConfiguration, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { constructor: [], rootUrl: [] });
/** @nocollapse */ GmsApiConfiguration.ngInjectableDef = ɵɵdefineInjectable({ factory: function GmsApiConfiguration_Factory() { return new GmsApiConfiguration(); }, token: GmsApiConfiguration, providedIn: "root" });
if (false) {
    /** @type {?} */
    GmsApiConfiguration.prototype.rootUrl;
}
/**
 * @record
 */
function GmsApiConfigurationInterface() { }
if (false) {
    /** @type {?|undefined} */
    GmsApiConfigurationInterface.prototype.rootUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysisconfigurations.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisconfigurationsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of AnalysisConfigurations accessible by the current JWT token.
     * @param {?} params The `AnalysisconfigurationsService.ListAnalysisConfigurationsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `manifestName`: Manifest Name for filtering results. Result items must match the provided analysis type
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisVersionDefinitionId`: Analysis Version Definition id for filtering results. Result items must match the provided analysis type
     *
     * @return {?} AnalysisConfigurations found and returned successfully.
     */
    listAnalysisConfigurationsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.manifestName != null)
            __params = __params.set('manifestName', params.manifestName.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.analysisVersionDefinitionId != null)
            __params = __params.set('analysisVersionDefinitionId', params.analysisVersionDefinitionId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisconfigurations`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of AnalysisConfigurations accessible by the current JWT token.
     * @param {?} params The `AnalysisconfigurationsService.ListAnalysisConfigurationsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `manifestName`: Manifest Name for filtering results. Result items must match the provided analysis type
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisVersionDefinitionId`: Analysis Version Definition id for filtering results. Result items must match the provided analysis type
     *
     * @return {?} AnalysisConfigurations found and returned successfully.
     */
    listAnalysisConfigurationsV2(params) {
        return this.listAnalysisConfigurationsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new AnalysisConfiguration
     * @param {?=} body undefined
     * @return {?} The AnalysisConfiguration is created successfully.
     */
    createAnalysisConfigurationV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/analysisconfigurations`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new AnalysisConfiguration
     * @param {?=} body undefined
     * @return {?} The AnalysisConfiguration is created successfully.
     */
    createAnalysisConfigurationV2(body) {
        return this.createAnalysisConfigurationV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Analysisconfiguration Id, returns information about that Analysisconfiguration accessible by the current JWT token.
     * @param {?} analysisConfigurationId undefined
     * @return {?} AnalysisConfiguration resource with the given ID is found and its details returned successfully.
     */
    getAnalysisConfigurationV2Response(analysisConfigurationId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisconfigurations/${analysisConfigurationId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Analysisconfiguration Id, returns information about that Analysisconfiguration accessible by the current JWT token.
     * @param {?} analysisConfigurationId undefined
     * @return {?} AnalysisConfiguration resource with the given ID is found and its details returned successfully.
     */
    getAnalysisConfigurationV2(analysisConfigurationId) {
        return this.getAnalysisConfigurationV2Response(analysisConfigurationId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing analysisConfiguration's metadata
     * @param {?} params The `AnalysisconfigurationsService.UpdateAnalysisConfigurationV2Params` containing the following parameters:
     *
     * - `analysisConfigurationId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisConfiguration is updated successfully.
     */
    updateAnalysisConfigurationV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/analysisconfigurations/${params.analysisConfigurationId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing analysisConfiguration's metadata
     * @param {?} params The `AnalysisconfigurationsService.UpdateAnalysisConfigurationV2Params` containing the following parameters:
     *
     * - `analysisConfigurationId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisConfiguration is updated successfully.
     */
    updateAnalysisConfigurationV2(params) {
        return this.updateAnalysisConfigurationV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisConfiguration Id, disables that AnalysisConfiguration with the current JWT token.
     * @param {?} analysisConfigurationId undefined
     * @return {?} AnalysisConfiguration for the given ID is disabled successfully.
     */
    disableAnalysisConfigurationV2Response(analysisConfigurationId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/analysisconfigurations/${analysisConfigurationId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisConfiguration Id, disables that AnalysisConfiguration with the current JWT token.
     * @param {?} analysisConfigurationId undefined
     * @return {?} AnalysisConfiguration for the given ID is disabled successfully.
     */
    disableAnalysisConfigurationV2(analysisConfigurationId) {
        return this.disableAnalysisConfigurationV2Response(analysisConfigurationId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisconfigurationsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisconfigurationsService, factory: function AnalysisconfigurationsService_Factory(t) { return new (t || AnalysisconfigurationsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisconfigurationsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisConfigurationsV2Response: [], listAnalysisConfigurationsV2: [], createAnalysisConfigurationV2Response: [], createAnalysisConfigurationV2: [], getAnalysisConfigurationV2Response: [], getAnalysisConfigurationV2: [], updateAnalysisConfigurationV2Response: [], updateAnalysisConfigurationV2: [], disableAnalysisConfigurationV2Response: [], disableAnalysisConfigurationV2: [] });
AnalysisconfigurationsService.listAnalysisConfigurationsV2Path = '/v2/infinium/analysisconfigurations';
AnalysisconfigurationsService.createAnalysisConfigurationV2Path = '/v2/infinium/analysisconfigurations';
AnalysisconfigurationsService.getAnalysisConfigurationV2Path = '/v2/infinium/analysisconfigurations/{analysisConfigurationId}';
AnalysisconfigurationsService.updateAnalysisConfigurationV2Path = '/v2/infinium/analysisconfigurations/{analysisConfigurationId}';
AnalysisconfigurationsService.disableAnalysisConfigurationV2Path = '/v2/infinium/analysisconfigurations/{analysisConfigurationId}';
/** @nocollapse */
AnalysisconfigurationsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisconfigurationsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisconfigurationsService_Factory() { return new AnalysisconfigurationsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisconfigurationsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisconfigurationsService.listAnalysisConfigurationsV2Path;
    /** @type {?} */
    AnalysisconfigurationsService.createAnalysisConfigurationV2Path;
    /** @type {?} */
    AnalysisconfigurationsService.getAnalysisConfigurationV2Path;
    /** @type {?} */
    AnalysisconfigurationsService.updateAnalysisConfigurationV2Path;
    /** @type {?} */
    AnalysisconfigurationsService.disableAnalysisConfigurationV2Path;
}
(function (AnalysisconfigurationsService) {
    /**
     * Parameters for listAnalysisConfigurationsV2
     * @record
     */
    function ListAnalysisConfigurationsV2Params() { }
    AnalysisconfigurationsService.ListAnalysisConfigurationsV2Params = ListAnalysisConfigurationsV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.pageSize;
        /**
         * Manifest Name for filtering results. Result items must match the provided analysis type
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.manifestName;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.include;
        /**
         * Analysis Version Definition id for filtering results. Result items must match the provided analysis type
         * @type {?|undefined}
         */
        ListAnalysisConfigurationsV2Params.prototype.analysisVersionDefinitionId;
    }
    /**
     * Parameters for updateAnalysisConfigurationV2
     * @record
     */
    function UpdateAnalysisConfigurationV2Params() { }
    AnalysisconfigurationsService.UpdateAnalysisConfigurationV2Params = UpdateAnalysisConfigurationV2Params;
    if (false) {
        /** @type {?} */
        UpdateAnalysisConfigurationV2Params.prototype.analysisConfigurationId;
        /** @type {?|undefined} */
        UpdateAnalysisConfigurationV2Params.prototype.body;
    }
})(AnalysisconfigurationsService || (AnalysisconfigurationsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysisdefinitions.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisdefinitionsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of AnalysisDefinitions accessible by the current JWT token.
     * @param {?} params The `AnalysisdefinitionsService.ListAnalysisDefinitionsV2Params` containing the following parameters:
     *
     * - `subscribedOnly`: Only analysis definitions that user is subscribed to
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} AnalysisDefinitions found and returned successfully.
     */
    listAnalysisDefinitionsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.subscribedOnly != null)
            __params = __params.set('subscribedOnly', params.subscribedOnly.toString());
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisdefinitions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of AnalysisDefinitions accessible by the current JWT token.
     * @param {?} params The `AnalysisdefinitionsService.ListAnalysisDefinitionsV2Params` containing the following parameters:
     *
     * - `subscribedOnly`: Only analysis definitions that user is subscribed to
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} AnalysisDefinitions found and returned successfully.
     */
    listAnalysisDefinitionsV2(params) {
        return this.listAnalysisDefinitionsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisDefinition Id, returns information about that AnalysisDefinition accessible by the current JWT token.
     * @param {?} analysisDefinitionId undefined
     * @return {?} AnalysisDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisDefinitionV2Response(analysisDefinitionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisdefinitions/${analysisDefinitionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisDefinition Id, returns information about that AnalysisDefinition accessible by the current JWT token.
     * @param {?} analysisDefinitionId undefined
     * @return {?} AnalysisDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisDefinitionV2(analysisDefinitionId) {
        return this.getAnalysisDefinitionV2Response(analysisDefinitionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisdefinitionsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisdefinitionsService, factory: function AnalysisdefinitionsService_Factory(t) { return new (t || AnalysisdefinitionsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisdefinitionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisDefinitionsV2Response: [], listAnalysisDefinitionsV2: [], getAnalysisDefinitionV2Response: [], getAnalysisDefinitionV2: [] });
AnalysisdefinitionsService.listAnalysisDefinitionsV2Path = '/v2/infinium/analysisdefinitions';
AnalysisdefinitionsService.getAnalysisDefinitionV2Path = '/v2/infinium/analysisdefinitions/{analysisDefinitionId}';
/** @nocollapse */
AnalysisdefinitionsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisdefinitionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisdefinitionsService_Factory() { return new AnalysisdefinitionsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisdefinitionsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisdefinitionsService.listAnalysisDefinitionsV2Path;
    /** @type {?} */
    AnalysisdefinitionsService.getAnalysisDefinitionV2Path;
}
(function (AnalysisdefinitionsService) {
    /**
     * Parameters for listAnalysisDefinitionsV2
     * @record
     */
    function ListAnalysisDefinitionsV2Params() { }
    AnalysisdefinitionsService.ListAnalysisDefinitionsV2Params = ListAnalysisDefinitionsV2Params;
    if (false) {
        /**
         * Only analysis definitions that user is subscribed to
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsV2Params.prototype.subscribedOnly;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsV2Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisDefinitionsV2Params.prototype.include;
    }
})(AnalysisdefinitionsService || (AnalysisdefinitionsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysisfiles.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisfilesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of AnalysisFiles accessible by the current JWT token.
     * @param {?} params The `AnalysisfilesService.ListAnalysisFilesV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `manifestName`: ManifestName for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisFileType`: AnalysisFileType for filtering results
     *
     * - `analysisFileName`: AnalysisFileName for filtering results
     *
     * @return {?} AnalysisFiles found and returned successfully.
     */
    listAnalysisFilesV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.manifestName != null)
            __params = __params.set('manifestName', params.manifestName.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.analysisFileType != null)
            __params = __params.set('analysisFileType', params.analysisFileType.toString());
        if (params.analysisFileName != null)
            __params = __params.set('analysisFileName', params.analysisFileName.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisfiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of AnalysisFiles accessible by the current JWT token.
     * @param {?} params The `AnalysisfilesService.ListAnalysisFilesV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `manifestName`: ManifestName for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisFileType`: AnalysisFileType for filtering results
     *
     * - `analysisFileName`: AnalysisFileName for filtering results
     *
     * @return {?} AnalysisFiles found and returned successfully.
     */
    listAnalysisFilesV2(params) {
        return this.listAnalysisFilesV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new analysisFile
     * @param {?=} body undefined
     * @return {?} The AnalysisFile is created successfully.
     */
    createAnalysisFileV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/analysisfiles`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new analysisFile
     * @param {?=} body undefined
     * @return {?} The AnalysisFile is created successfully.
     */
    createAnalysisFileV2(body) {
        return this.createAnalysisFileV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisFile Id, returns information about that AnalysisFile accessible by the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile resource with the given ID is found and its details returned successfully.
     */
    getAnalysisFileV2Response(analysisFileId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisfiles/${analysisFileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisFile Id, returns information about that AnalysisFile accessible by the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile resource with the given ID is found and its details returned successfully.
     */
    getAnalysisFileV2(analysisFileId) {
        return this.getAnalysisFileV2Response(analysisFileId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing analysisFile's metadata
     * @param {?} params The `AnalysisfilesService.UpdateAnalysisFileV2Params` containing the following parameters:
     *
     * - `analysisFileId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisFile is updated successfully.
     */
    updateAnalysisFileV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/analysisfiles/${params.analysisFileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing analysisFile's metadata
     * @param {?} params The `AnalysisfilesService.UpdateAnalysisFileV2Params` containing the following parameters:
     *
     * - `analysisFileId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisFile is updated successfully.
     */
    updateAnalysisFileV2(params) {
        return this.updateAnalysisFileV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisFile Id, disables that AnalysisFile with the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile for the given ID is disabled successfully.
     */
    disableAnalysisFileV2Response(analysisFileId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/analysisfiles/${analysisFileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisFile Id, disables that AnalysisFile with the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile for the given ID is disabled successfully.
     */
    disableAnalysisFileV2(analysisFileId) {
        return this.disableAnalysisFileV2Response(analysisFileId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisFile Id, returns data download URL for AnalysisFile accessible by the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile resource with the given ID is found and download URL returned successfully..
     */
    createAnalysisFileDownloadUrlV2Response(analysisFileId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/analysisfiles/${analysisFileId}:createDownloadUrl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisFile Id, returns data download URL for AnalysisFile accessible by the current JWT token.
     * @param {?} analysisFileId undefined
     * @return {?} AnalysisFile resource with the given ID is found and download URL returned successfully..
     */
    createAnalysisFileDownloadUrlV2(analysisFileId) {
        return this.createAnalysisFileDownloadUrlV2Response(analysisFileId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisfilesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisfilesService, factory: function AnalysisfilesService_Factory(t) { return new (t || AnalysisfilesService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisfilesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisFilesV2Response: [], listAnalysisFilesV2: [], createAnalysisFileV2Response: [], createAnalysisFileV2: [], getAnalysisFileV2Response: [], getAnalysisFileV2: [], updateAnalysisFileV2Response: [], updateAnalysisFileV2: [], disableAnalysisFileV2Response: [], disableAnalysisFileV2: [], createAnalysisFileDownloadUrlV2Response: [], createAnalysisFileDownloadUrlV2: [] });
AnalysisfilesService.listAnalysisFilesV2Path = '/v2/infinium/analysisfiles';
AnalysisfilesService.createAnalysisFileV2Path = '/v2/infinium/analysisfiles';
AnalysisfilesService.getAnalysisFileV2Path = '/v2/infinium/analysisfiles/{analysisFileId}';
AnalysisfilesService.updateAnalysisFileV2Path = '/v2/infinium/analysisfiles/{analysisFileId}';
AnalysisfilesService.disableAnalysisFileV2Path = '/v2/infinium/analysisfiles/{analysisFileId}';
AnalysisfilesService.createAnalysisFileDownloadUrlV2Path = '/v2/infinium/analysisfiles/{analysisFileId}:createDownloadUrl';
/** @nocollapse */
AnalysisfilesService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisfilesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisfilesService_Factory() { return new AnalysisfilesService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisfilesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisfilesService.listAnalysisFilesV2Path;
    /** @type {?} */
    AnalysisfilesService.createAnalysisFileV2Path;
    /** @type {?} */
    AnalysisfilesService.getAnalysisFileV2Path;
    /** @type {?} */
    AnalysisfilesService.updateAnalysisFileV2Path;
    /** @type {?} */
    AnalysisfilesService.disableAnalysisFileV2Path;
    /** @type {?} */
    AnalysisfilesService.createAnalysisFileDownloadUrlV2Path;
}
(function (AnalysisfilesService) {
    /**
     * Parameters for listAnalysisFilesV2
     * @record
     */
    function ListAnalysisFilesV2Params() { }
    AnalysisfilesService.ListAnalysisFilesV2Params = ListAnalysisFilesV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.pageSize;
        /**
         * ManifestName for filtering results
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.manifestName;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.include;
        /**
         * AnalysisFileType for filtering results
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.analysisFileType;
        /**
         * AnalysisFileName for filtering results
         * @type {?|undefined}
         */
        ListAnalysisFilesV2Params.prototype.analysisFileName;
    }
    /**
     * Parameters for updateAnalysisFileV2
     * @record
     */
    function UpdateAnalysisFileV2Params() { }
    AnalysisfilesService.UpdateAnalysisFileV2Params = UpdateAnalysisFileV2Params;
    if (false) {
        /** @type {?} */
        UpdateAnalysisFileV2Params.prototype.analysisFileId;
        /** @type {?|undefined} */
        UpdateAnalysisFileV2Params.prototype.body;
    }
})(AnalysisfilesService || (AnalysisfilesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysisruns.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisrunsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of AnalysisRun accessible by the current JWT token.
     * @param {?} params The `AnalysisrunsService.ListAnalysisRunsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `beadchipName`: Beadchip Name for filtering results. Result items must match the provided beadchip name.
     *
     * @return {?} AnalysisRun found and returned successfully.
     */
    listAnalysisRunsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.beadchipName != null)
            __params = __params.set('beadchipName', params.beadchipName.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisruns`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of AnalysisRun accessible by the current JWT token.
     * @param {?} params The `AnalysisrunsService.ListAnalysisRunsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `beadchipName`: Beadchip Name for filtering results. Result items must match the provided beadchip name.
     *
     * @return {?} AnalysisRun found and returned successfully.
     */
    listAnalysisRunsV2(params) {
        return this.listAnalysisRunsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new AnalysisRun
     * @param {?=} body undefined
     * @return {?} The AnalysisRun is created successfully.
     */
    createAnalysisRunV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/analysisruns`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new AnalysisRun
     * @param {?=} body undefined
     * @return {?} The AnalysisRun is created successfully.
     */
    createAnalysisRunV2(body) {
        return this.createAnalysisRunV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing analysisRun's metadata
     * @param {?} params The `AnalysisrunsService.UpdateAnalysisRunV2Params` containing the following parameters:
     *
     * - `analysisRunId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisRun is updated successfully.
     */
    updateAnalysisRunV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/analysisruns/${params.analysisRunId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing analysisRun's metadata
     * @param {?} params The `AnalysisrunsService.UpdateAnalysisRunV2Params` containing the following parameters:
     *
     * - `analysisRunId`:
     *
     * - `body`:
     *
     * @return {?} The AnalysisRun is updated successfully.
     */
    updateAnalysisRunV2(params) {
        return this.updateAnalysisRunV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisRun Id, returns information about that AnalysisRun accessible by the current JWT token.
     * @param {?} analysisRunId undefined
     * @return {?} AnalysisRun resource with the given ID is found and its details returned successfully.
     */
    getAnalysisRunV2Response(analysisRunId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisruns/${analysisRunId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisRun Id, returns information about that AnalysisRun accessible by the current JWT token.
     * @param {?} analysisRunId undefined
     * @return {?} AnalysisRun resource with the given ID is found and its details returned successfully.
     */
    getAnalysisRunV2(analysisRunId) {
        return this.getAnalysisRunV2Response(analysisRunId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisRun Id, disables that AnalysisRun with the current JWT token.
     * @param {?} analysisRunId undefined
     * @return {?} AnalysisRun for the given ID is disabled successfully.
     */
    disableAnalysisRunV2Response(analysisRunId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/analysisruns/${analysisRunId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisRun Id, disables that AnalysisRun with the current JWT token.
     * @param {?} analysisRunId undefined
     * @return {?} AnalysisRun for the given ID is disabled successfully.
     */
    disableAnalysisRunV2(analysisRunId) {
        return this.disableAnalysisRunV2Response(analysisRunId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisrunsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisrunsService, factory: function AnalysisrunsService_Factory(t) { return new (t || AnalysisrunsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisrunsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisRunsV2Response: [], listAnalysisRunsV2: [], createAnalysisRunV2Response: [], createAnalysisRunV2: [], updateAnalysisRunV2Response: [], updateAnalysisRunV2: [], getAnalysisRunV2Response: [], getAnalysisRunV2: [], disableAnalysisRunV2Response: [], disableAnalysisRunV2: [] });
AnalysisrunsService.listAnalysisRunsV2Path = '/v2/infinium/analysisruns';
AnalysisrunsService.createAnalysisRunV2Path = '/v2/infinium/analysisruns';
AnalysisrunsService.updateAnalysisRunV2Path = '/v2/infinium/analysisruns/{analysisRunId}';
AnalysisrunsService.getAnalysisRunV2Path = '/v2/infinium/analysisruns/{analysisRunId}';
AnalysisrunsService.disableAnalysisRunV2Path = '/v2/infinium/analysisruns/{analysisRunId}';
/** @nocollapse */
AnalysisrunsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisrunsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisrunsService_Factory() { return new AnalysisrunsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisrunsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisrunsService.listAnalysisRunsV2Path;
    /** @type {?} */
    AnalysisrunsService.createAnalysisRunV2Path;
    /** @type {?} */
    AnalysisrunsService.updateAnalysisRunV2Path;
    /** @type {?} */
    AnalysisrunsService.getAnalysisRunV2Path;
    /** @type {?} */
    AnalysisrunsService.disableAnalysisRunV2Path;
}
(function (AnalysisrunsService) {
    /**
     * Parameters for listAnalysisRunsV2
     * @record
     */
    function ListAnalysisRunsV2Params() { }
    AnalysisrunsService.ListAnalysisRunsV2Params = ListAnalysisRunsV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisRunsV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisRunsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisRunsV2Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisRunsV2Params.prototype.include;
        /**
         * Beadchip Name for filtering results. Result items must match the provided beadchip name.
         * @type {?|undefined}
         */
        ListAnalysisRunsV2Params.prototype.beadchipName;
    }
    /**
     * Parameters for updateAnalysisRunV2
     * @record
     */
    function UpdateAnalysisRunV2Params() { }
    AnalysisrunsService.UpdateAnalysisRunV2Params = UpdateAnalysisRunV2Params;
    if (false) {
        /** @type {?} */
        UpdateAnalysisRunV2Params.prototype.analysisRunId;
        /** @type {?|undefined} */
        UpdateAnalysisRunV2Params.prototype.body;
    }
})(AnalysisrunsService || (AnalysisrunsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/analysisversiondefinitions.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalysisversiondefinitionsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of AnalysisVersionDefinitions accessible by the current JWT token.
     * @param {?} params The `AnalysisversiondefinitionsService.ListAnalysisVersionDefinitionsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisDefinitionId`: Analysis definition ID for filtering results. Result items must match the provided analysisDefinition Id.
     *
     * @return {?} AnalysisVersionDefinitions found and returned successfully.
     */
    listAnalysisVersionDefinitionsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.analysisDefinitionId != null)
            __params = __params.set('analysisDefinitionId', params.analysisDefinitionId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisversiondefinitions`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of AnalysisVersionDefinitions accessible by the current JWT token.
     * @param {?} params The `AnalysisversiondefinitionsService.ListAnalysisVersionDefinitionsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `analysisDefinitionId`: Analysis definition ID for filtering results. Result items must match the provided analysisDefinition Id.
     *
     * @return {?} AnalysisVersionDefinitions found and returned successfully.
     */
    listAnalysisVersionDefinitionsV2(params) {
        return this.listAnalysisVersionDefinitionsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisVersionDefinition Id, returns information about that AnalysisVersionDefinition accessible by the current JWT token.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisVersionDefinitionV2Response(analysisVersionDefinitionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisversiondefinitions/${analysisVersionDefinitionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisVersionDefinition Id, returns information about that AnalysisVersionDefinition accessible by the current JWT token.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisVersionDefinitionV2(analysisVersionDefinitionId) {
        return this.getAnalysisVersionDefinitionV2Response(analysisVersionDefinitionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisVersionDefinition Id, returns the BSSH UI form controls for that AnalysisVersionDefinition accessible by the current JWT token.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisVersionDefinitionFormControlsV2Response(analysisVersionDefinitionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/analysisversiondefinitions/${analysisVersionDefinitionId}/formcontrols`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisVersionDefinition Id, returns the BSSH UI form controls for that AnalysisVersionDefinition accessible by the current JWT token.
     * @param {?} analysisVersionDefinitionId undefined
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and its details returned successfully.
     */
    getAnalysisVersionDefinitionFormControlsV2(analysisVersionDefinitionId) {
        return this.getAnalysisVersionDefinitionFormControlsV2Response(analysisVersionDefinitionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a AnalysisVersionDefination Id and AnalysisFileType, returns template download URL for AnalysisFile accessible by the current JWT token.
     * @param {?} params The `AnalysisversiondefinitionsService.CreateTemplateDownloadUrlV2Params` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `analysisFileType`:
     *
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and download URL returned successfully.
     */
    createTemplateDownloadUrlV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/analysisversiondefinitions/${params.analysisVersionDefinitionId}/${params.analysisFileType}:createTemplateDownloadUrl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a AnalysisVersionDefination Id and AnalysisFileType, returns template download URL for AnalysisFile accessible by the current JWT token.
     * @param {?} params The `AnalysisversiondefinitionsService.CreateTemplateDownloadUrlV2Params` containing the following parameters:
     *
     * - `analysisVersionDefinitionId`:
     *
     * - `analysisFileType`:
     *
     * @return {?} AnalysisVersionDefinition resource with the given ID is found and download URL returned successfully.
     */
    createTemplateDownloadUrlV2(params) {
        return this.createTemplateDownloadUrlV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
AnalysisversiondefinitionsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: AnalysisversiondefinitionsService, factory: function AnalysisversiondefinitionsService_Factory(t) { return new (t || AnalysisversiondefinitionsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AnalysisversiondefinitionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listAnalysisVersionDefinitionsV2Response: [], listAnalysisVersionDefinitionsV2: [], getAnalysisVersionDefinitionV2Response: [], getAnalysisVersionDefinitionV2: [], getAnalysisVersionDefinitionFormControlsV2Response: [], getAnalysisVersionDefinitionFormControlsV2: [], createTemplateDownloadUrlV2Response: [], createTemplateDownloadUrlV2: [] });
AnalysisversiondefinitionsService.listAnalysisVersionDefinitionsV2Path = '/v2/infinium/analysisversiondefinitions';
AnalysisversiondefinitionsService.getAnalysisVersionDefinitionV2Path = '/v2/infinium/analysisversiondefinitions/{analysisVersionDefinitionId}';
AnalysisversiondefinitionsService.getAnalysisVersionDefinitionFormControlsV2Path = '/v2/infinium/analysisversiondefinitions/{analysisVersionDefinitionId}/formcontrols';
AnalysisversiondefinitionsService.createTemplateDownloadUrlV2Path = '/v2/infinium/analysisversiondefinitions/{analysisVersionDefinitionId}/{analysisFileType}:createTemplateDownloadUrl';
/** @nocollapse */
AnalysisversiondefinitionsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ AnalysisversiondefinitionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AnalysisversiondefinitionsService_Factory() { return new AnalysisversiondefinitionsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: AnalysisversiondefinitionsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    AnalysisversiondefinitionsService.listAnalysisVersionDefinitionsV2Path;
    /** @type {?} */
    AnalysisversiondefinitionsService.getAnalysisVersionDefinitionV2Path;
    /** @type {?} */
    AnalysisversiondefinitionsService.getAnalysisVersionDefinitionFormControlsV2Path;
    /** @type {?} */
    AnalysisversiondefinitionsService.createTemplateDownloadUrlV2Path;
}
(function (AnalysisversiondefinitionsService) {
    /**
     * Parameters for listAnalysisVersionDefinitionsV2
     * @record
     */
    function ListAnalysisVersionDefinitionsV2Params() { }
    AnalysisversiondefinitionsService.ListAnalysisVersionDefinitionsV2Params = ListAnalysisVersionDefinitionsV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsV2Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsV2Params.prototype.include;
        /**
         * Analysis definition ID for filtering results. Result items must match the provided analysisDefinition Id.
         * @type {?|undefined}
         */
        ListAnalysisVersionDefinitionsV2Params.prototype.analysisDefinitionId;
    }
    /**
     * Parameters for createTemplateDownloadUrlV2
     * @record
     */
    function CreateTemplateDownloadUrlV2Params() { }
    AnalysisversiondefinitionsService.CreateTemplateDownloadUrlV2Params = CreateTemplateDownloadUrlV2Params;
    if (false) {
        /** @type {?} */
        CreateTemplateDownloadUrlV2Params.prototype.analysisVersionDefinitionId;
        /** @type {?} */
        CreateTemplateDownloadUrlV2Params.prototype.analysisFileType;
    }
})(AnalysisversiondefinitionsService || (AnalysisversiondefinitionsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/beadchips.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BeadchipsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of BeadChips accessible by the current JWT token.
     * @param {?} params The `BeadchipsService.ListBeadChipsV2Params` containing the following parameters:
     *
     * - `successfullyScannedOnly`: Successfully Scanned Only
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Revision for filtering results
     *
     * - `productPartNumber`: Part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Name for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} BeadChips found and returned successfully.
     */
    listBeadChipsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.successfullyScannedOnly != null)
            __params = __params.set('successfullyScannedOnly', params.successfullyScannedOnly.toString());
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.productRevision != null)
            __params = __params.set('productRevision', params.productRevision.toString());
        if (params.productPartNumber != null)
            __params = __params.set('productPartNumber', params.productPartNumber.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/beadchips`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of BeadChips accessible by the current JWT token.
     * @param {?} params The `BeadchipsService.ListBeadChipsV2Params` containing the following parameters:
     *
     * - `successfullyScannedOnly`: Successfully Scanned Only
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Revision for filtering results
     *
     * - `productPartNumber`: Part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Name for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} BeadChips found and returned successfully.
     */
    listBeadChipsV2(params) {
        return this.listBeadChipsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new bead chip
     * @param {?=} body undefined
     * @return {?} The BeadChip is created successfully.
     */
    createBeadChipV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/beadchips`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new bead chip
     * @param {?=} body undefined
     * @return {?} The BeadChip is created successfully.
     */
    createBeadChipV2(body) {
        return this.createBeadChipV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing beadChip's metadata
     * @param {?} params The `BeadchipsService.UpdateBeadChipV2Params` containing the following parameters:
     *
     * - `beadchipId`:
     *
     * - `body`:
     *
     * @return {?} The BeadChip is updated successfully.
     */
    updateBeadChipV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/beadchips/${params.beadchipId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing beadChip's metadata
     * @param {?} params The `BeadchipsService.UpdateBeadChipV2Params` containing the following parameters:
     *
     * - `beadchipId`:
     *
     * - `body`:
     *
     * @return {?} The BeadChip is updated successfully.
     */
    updateBeadChipV2(params) {
        return this.updateBeadChipV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a BeadChip Id, returns information about that BeadChip accessible by the current JWT token.
     * @param {?} beadchipId undefined
     * @return {?} BeadChip resource with the given ID is found and its details returned successfully.
     */
    getBeadChipV2Response(beadchipId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/beadchips/${beadchipId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a BeadChip Id, returns information about that BeadChip accessible by the current JWT token.
     * @param {?} beadchipId undefined
     * @return {?} BeadChip resource with the given ID is found and its details returned successfully.
     */
    getBeadChipV2(beadchipId) {
        return this.getBeadChipV2Response(beadchipId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a BeadChip Id, disables that BeadChip with the current JWT token.
     * @param {?} beadchipId undefined
     * @return {?} BeadChip for the given ID is disabled successfully.
     */
    disableBeadChipV2Response(beadchipId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/beadchips/${beadchipId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a BeadChip Id, disables that BeadChip with the current JWT token.
     * @param {?} beadchipId undefined
     * @return {?} BeadChip for the given ID is disabled successfully.
     */
    disableBeadChipV2(beadchipId) {
        return this.disableBeadChipV2Response(beadchipId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
BeadchipsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: BeadchipsService, factory: function BeadchipsService_Factory(t) { return new (t || BeadchipsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(BeadchipsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listBeadChipsV2Response: [], listBeadChipsV2: [], createBeadChipV2Response: [], createBeadChipV2: [], updateBeadChipV2Response: [], updateBeadChipV2: [], getBeadChipV2Response: [], getBeadChipV2: [], disableBeadChipV2Response: [], disableBeadChipV2: [] });
BeadchipsService.listBeadChipsV2Path = '/v2/infinium/beadchips';
BeadchipsService.createBeadChipV2Path = '/v2/infinium/beadchips';
BeadchipsService.updateBeadChipV2Path = '/v2/infinium/beadchips/{beadchipId}';
BeadchipsService.getBeadChipV2Path = '/v2/infinium/beadchips/{beadchipId}';
BeadchipsService.disableBeadChipV2Path = '/v2/infinium/beadchips/{beadchipId}';
/** @nocollapse */
BeadchipsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ BeadchipsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function BeadchipsService_Factory() { return new BeadchipsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: BeadchipsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    BeadchipsService.listBeadChipsV2Path;
    /** @type {?} */
    BeadchipsService.createBeadChipV2Path;
    /** @type {?} */
    BeadchipsService.updateBeadChipV2Path;
    /** @type {?} */
    BeadchipsService.getBeadChipV2Path;
    /** @type {?} */
    BeadchipsService.disableBeadChipV2Path;
}
(function (BeadchipsService) {
    /**
     * Parameters for listBeadChipsV2
     * @record
     */
    function ListBeadChipsV2Params() { }
    BeadchipsService.ListBeadChipsV2Params = ListBeadChipsV2Params;
    if (false) {
        /**
         * Successfully Scanned Only
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.successfullyScannedOnly;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.sort;
        /**
         * Revision for filtering results
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.productRevision;
        /**
         * Part number for filtering results
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.productPartNumber;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.pageSize;
        /**
         * Name for filtering results
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.name;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListBeadChipsV2Params.prototype.include;
    }
    /**
     * Parameters for updateBeadChipV2
     * @record
     */
    function UpdateBeadChipV2Params() { }
    BeadchipsService.UpdateBeadChipV2Params = UpdateBeadChipV2Params;
    if (false) {
        /** @type {?} */
        UpdateBeadChipV2Params.prototype.beadchipId;
        /** @type {?|undefined} */
        UpdateBeadChipV2Params.prototype.body;
    }
})(BeadchipsService || (BeadchipsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/idats-upload.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IdatsUploadService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Takes a list of Sample identifiers and returns UploadSession along with other peripheral details like runIds that are created as part of upload
     * @param {?=} body undefined
     * @return {?} Created
     */
    CreateUploadSessionResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/idatUploads`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Takes a list of Sample identifiers and returns UploadSession along with other peripheral details like runIds that are created as part of upload
     * @param {?=} body undefined
     * @return {?} Created
     */
    CreateUploadSession(body) {
        return this.CreateUploadSessionResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Retrieves the details of a specific idats upload operation by its uploadSessionId.
     * @param {?} uploadSessionId undefined
     * @return {?} Returns the details of the idats upload operation.
     */
    GetIdatsUploadResponse(uploadSessionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/idatUploads/${uploadSessionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Retrieves the details of a specific idats upload operation by its uploadSessionId.
     * @param {?} uploadSessionId undefined
     * @return {?} Returns the details of the idats upload operation.
     */
    GetIdatsUpload(uploadSessionId) {
        return this.GetIdatsUploadResponse(uploadSessionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Deletes the specified Idat upload session.
     * @param {?} uploadSessionId The Idat upload session ID.
     * @return {?}
     */
    DeleteIdatsUploadSessionResponse(uploadSessionId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/idatUploads/${uploadSessionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Deletes the specified Idat upload session.
     * @param {?} uploadSessionId The Idat upload session ID.
     * @return {?}
     */
    DeleteIdatsUploadSession(uploadSessionId) {
        return this.DeleteIdatsUploadSessionResponse(uploadSessionId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
IdatsUploadService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: IdatsUploadService, factory: function IdatsUploadService_Factory(t) { return new (t || IdatsUploadService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(IdatsUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], CreateUploadSessionResponse: [], CreateUploadSession: [], GetIdatsUploadResponse: [], GetIdatsUpload: [], DeleteIdatsUploadSessionResponse: [], DeleteIdatsUploadSession: [] });
IdatsUploadService.CreateUploadSessionPath = '/v2/infinium/idatUploads';
IdatsUploadService.GetIdatsUploadPath = '/v2/infinium/idatUploads/{uploadSessionId}';
IdatsUploadService.DeleteIdatsUploadSessionPath = '/v2/infinium/idatUploads/{uploadSessionId}';
/** @nocollapse */
IdatsUploadService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ IdatsUploadService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IdatsUploadService_Factory() { return new IdatsUploadService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: IdatsUploadService, providedIn: "root" });
if (false) {
    /** @type {?} */
    IdatsUploadService.CreateUploadSessionPath;
    /** @type {?} */
    IdatsUploadService.GetIdatsUploadPath;
    /** @type {?} */
    IdatsUploadService.DeleteIdatsUploadSessionPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/manifests.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ManifestsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of Manifests accessible by the current JWT token.
     * @param {?} params The `ManifestsService.ListManifestsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Name for filtering results
     *
     * - `productPartNumber`: Name for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Name for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Manifests found and returned successfully.
     */
    listManifestsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.productRevision != null)
            __params = __params.set('productRevision', params.productRevision.toString());
        if (params.productPartNumber != null)
            __params = __params.set('productPartNumber', params.productPartNumber.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.name != null)
            __params = __params.set('name', params.name.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/manifests`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of Manifests accessible by the current JWT token.
     * @param {?} params The `ManifestsService.ListManifestsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Name for filtering results
     *
     * - `productPartNumber`: Name for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `name`: Name for filtering results
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Manifests found and returned successfully.
     */
    listManifestsV2(params) {
        return this.listManifestsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new manifest
     * @param {?=} body undefined
     * @return {?} The Manifest is created successfully.
     */
    createManifestV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/manifests`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new manifest
     * @param {?=} body undefined
     * @return {?} The Manifest is created successfully.
     */
    createManifestV2(body) {
        return this.createManifestV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Manifest Id, returns information about that Manifest accessible by the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest resource with the given ID is found and its details returned successfully.
     */
    getManifestV2Response(manifestId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/manifests/${manifestId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Manifest Id, returns information about that Manifest accessible by the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest resource with the given ID is found and its details returned successfully.
     */
    getManifestV2(manifestId) {
        return this.getManifestV2Response(manifestId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing manifest's metadata
     * @param {?} params The `ManifestsService.UpdateManifestV2Params` containing the following parameters:
     *
     * - `manifestId`:
     *
     * - `body`:
     *
     * @return {?} The Manifest is updated successfully.
     */
    updateManifestV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/manifests/${params.manifestId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing manifest's metadata
     * @param {?} params The `ManifestsService.UpdateManifestV2Params` containing the following parameters:
     *
     * - `manifestId`:
     *
     * - `body`:
     *
     * @return {?} The Manifest is updated successfully.
     */
    updateManifestV2(params) {
        return this.updateManifestV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Manifest Id, disables that Manifest with the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest for the given ID is disabled successfully.
     */
    disableManifestV2Response(manifestId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/manifests/${manifestId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Manifest Id, disables that Manifest with the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest for the given ID is disabled successfully.
     */
    disableManifestV2(manifestId) {
        return this.disableManifestV2Response(manifestId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Manifest Id, returns data download URL for Manifest accessible by the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest resource with the given ID is found and download URL returned successfully.
     */
    createManifestDownloadUrlV2Response(manifestId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/manifests/${manifestId}:createDownloadUrl`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Manifest Id, returns data download URL for Manifest accessible by the current JWT token.
     * @param {?} manifestId undefined
     * @return {?} Manifest resource with the given ID is found and download URL returned successfully.
     */
    createManifestDownloadUrlV2(manifestId) {
        return this.createManifestDownloadUrlV2Response(manifestId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
ManifestsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: ManifestsService, factory: function ManifestsService_Factory(t) { return new (t || ManifestsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ManifestsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listManifestsV2Response: [], listManifestsV2: [], createManifestV2Response: [], createManifestV2: [], getManifestV2Response: [], getManifestV2: [], updateManifestV2Response: [], updateManifestV2: [], disableManifestV2Response: [], disableManifestV2: [], createManifestDownloadUrlV2Response: [], createManifestDownloadUrlV2: [] });
ManifestsService.listManifestsV2Path = '/v2/infinium/manifests';
ManifestsService.createManifestV2Path = '/v2/infinium/manifests';
ManifestsService.getManifestV2Path = '/v2/infinium/manifests/{manifestId}';
ManifestsService.updateManifestV2Path = '/v2/infinium/manifests/{manifestId}';
ManifestsService.disableManifestV2Path = '/v2/infinium/manifests/{manifestId}';
ManifestsService.createManifestDownloadUrlV2Path = '/v2/infinium/manifests/{manifestId}:createDownloadUrl';
/** @nocollapse */
ManifestsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ ManifestsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ManifestsService_Factory() { return new ManifestsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: ManifestsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ManifestsService.listManifestsV2Path;
    /** @type {?} */
    ManifestsService.createManifestV2Path;
    /** @type {?} */
    ManifestsService.getManifestV2Path;
    /** @type {?} */
    ManifestsService.updateManifestV2Path;
    /** @type {?} */
    ManifestsService.disableManifestV2Path;
    /** @type {?} */
    ManifestsService.createManifestDownloadUrlV2Path;
}
(function (ManifestsService) {
    /**
     * Parameters for listManifestsV2
     * @record
     */
    function ListManifestsV2Params() { }
    ManifestsService.ListManifestsV2Params = ListManifestsV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.sort;
        /**
         * Name for filtering results
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.productRevision;
        /**
         * Name for filtering results
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.productPartNumber;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.pageSize;
        /**
         * Name for filtering results
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.name;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListManifestsV2Params.prototype.include;
    }
    /**
     * Parameters for updateManifestV2
     * @record
     */
    function UpdateManifestV2Params() { }
    ManifestsService.UpdateManifestV2Params = UpdateManifestV2Params;
    if (false) {
        /** @type {?} */
        UpdateManifestV2Params.prototype.manifestId;
        /** @type {?|undefined} */
        UpdateManifestV2Params.prototype.body;
    }
})(ManifestsService || (ManifestsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/products.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of Products accessible by the current JWT token.
     * @param {?} params The `ProductsService.ListProductsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `revision`: Revision for filtering results
     *
     * - `partNumber`: Part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Products found and returned successfully.
     */
    listProductsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.revision != null)
            __params = __params.set('revision', params.revision.toString());
        if (params.partNumber != null)
            __params = __params.set('partNumber', params.partNumber.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/products`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of Products accessible by the current JWT token.
     * @param {?} params The `ProductsService.ListProductsV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `revision`: Revision for filtering results
     *
     * - `partNumber`: Part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * @return {?} Products found and returned successfully.
     */
    listProductsV2(params) {
        return this.listProductsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new product
     * @param {?=} body undefined
     * @return {?} The Product is created successfully.
     */
    createProductV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/products`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new product
     * @param {?=} body undefined
     * @return {?} The Product is created successfully.
     */
    createProductV2(body) {
        return this.createProductV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Product Id, returns information about that Product accessible by the current JWT token.
     * @param {?} productId undefined
     * @return {?} Product resource with the given ID is found and its details returned successfully.
     */
    getProductV2Response(productId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/products/${productId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Product Id, returns information about that Product accessible by the current JWT token.
     * @param {?} productId undefined
     * @return {?} Product resource with the given ID is found and its details returned successfully.
     */
    getProductV2(productId) {
        return this.getProductV2Response(productId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing product's metadata
     * @param {?} params The `ProductsService.UpdateProductV2Params` containing the following parameters:
     *
     * - `productId`:
     *
     * - `body`:
     *
     * @return {?} The Product is updated successfully.
     */
    updateProductV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/products/${params.productId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing product's metadata
     * @param {?} params The `ProductsService.UpdateProductV2Params` containing the following parameters:
     *
     * - `productId`:
     *
     * - `body`:
     *
     * @return {?} The Product is updated successfully.
     */
    updateProductV2(params) {
        return this.updateProductV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Product Id, disables that Product with the current JWT token.
     * @param {?} productId undefined
     * @return {?} Product for the given ID is disabled successfully.
     */
    disableProductV2Response(productId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/products/${productId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Product Id, disables that Product with the current JWT token.
     * @param {?} productId undefined
     * @return {?} Product for the given ID is disabled successfully.
     */
    disableProductV2(productId) {
        return this.disableProductV2Response(productId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
ProductsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: ProductsService, factory: function ProductsService_Factory(t) { return new (t || ProductsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ProductsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listProductsV2Response: [], listProductsV2: [], createProductV2Response: [], createProductV2: [], getProductV2Response: [], getProductV2: [], updateProductV2Response: [], updateProductV2: [], disableProductV2Response: [], disableProductV2: [] });
ProductsService.listProductsV2Path = '/v2/infinium/products';
ProductsService.createProductV2Path = '/v2/infinium/products';
ProductsService.getProductV2Path = '/v2/infinium/products/{productId}';
ProductsService.updateProductV2Path = '/v2/infinium/products/{productId}';
ProductsService.disableProductV2Path = '/v2/infinium/products/{productId}';
/** @nocollapse */
ProductsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ ProductsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProductsService_Factory() { return new ProductsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: ProductsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ProductsService.listProductsV2Path;
    /** @type {?} */
    ProductsService.createProductV2Path;
    /** @type {?} */
    ProductsService.getProductV2Path;
    /** @type {?} */
    ProductsService.updateProductV2Path;
    /** @type {?} */
    ProductsService.disableProductV2Path;
}
(function (ProductsService) {
    /**
     * Parameters for listProductsV2
     * @record
     */
    function ListProductsV2Params() { }
    ProductsService.ListProductsV2Params = ListProductsV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.sort;
        /**
         * Revision for filtering results
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.revision;
        /**
         * Part number for filtering results
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.partNumber;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListProductsV2Params.prototype.include;
    }
    /**
     * Parameters for updateProductV2
     * @record
     */
    function UpdateProductV2Params() { }
    ProductsService.UpdateProductV2Params = UpdateProductV2Params;
    if (false) {
        /** @type {?} */
        UpdateProductV2Params.prototype.productId;
        /** @type {?|undefined} */
        UpdateProductV2Params.prototype.body;
    }
})(ProductsService || (ProductsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/run-data-upload.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RunDataUploadService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Check the status of the run and returns whether the run is ready to be uploaded.
     * @param {?} params The `RunDataUploadService.CanUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Run is ready to upload
     */
    canUploadRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:canUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Check the status of the run and returns whether the run is ready to be uploaded.
     * @param {?} params The `RunDataUploadService.CanUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Run is ready to upload
     */
    canUploadRunDataV2(params) {
        return this.canUploadRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given context ID, performs pre-run connectivity check for the run data upload.
     * @param {?} params The `RunDataUploadService.ConnectivityCheckRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Pre-upload connectivity check is successful.
     */
    connectivityCheckRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:connectivityCheck`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given context ID, performs pre-run connectivity check for the run data upload.
     * @param {?} params The `RunDataUploadService.ConnectivityCheckRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Pre-upload connectivity check is successful.
     */
    connectivityCheckRunDataV2(params) {
        return this.connectivityCheckRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Start run upload
     * @param {?} params The `RunDataUploadService.StartUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload is started successfully
     */
    startUploadRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:startUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Start run upload
     * @param {?} params The `RunDataUploadService.StartUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload is started successfully
     */
    startUploadRunDataV2(params) {
        return this.startUploadRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given context ID, provides information about the file upload path in the destination. GMS returns empty response with FilePathPrefix=null
     * @param {?} params The `RunDataUploadService.GetFileUploadPathRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} File upload path information is found successfully.
     */
    getFileUploadPathRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:getFileUploadPath`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given context ID, provides information about the file upload path in the destination. GMS returns empty response with FilePathPrefix=null
     * @param {?} params The `RunDataUploadService.GetFileUploadPathRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} File upload path information is found successfully.
     */
    getFileUploadPathRunDataV2(params) {
        return this.getFileUploadPathRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given runId, provide information about an uploaded file or set of files.
     * @param {?} params The `RunDataUploadService.DirectUploadInfoRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload information captured successfully.
     */
    directUploadInfoRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}/directUploadInfo`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given runId, provide information about an uploaded file or set of files.
     * @param {?} params The `RunDataUploadService.DirectUploadInfoRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload information captured successfully.
     */
    directUploadInfoRunDataV2(params) {
        return this.directUploadInfoRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given runId, update the upload status of the run.
     * @param {?} params The `RunDataUploadService.UpdateUploadStatusRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} The resources upload completed successfully.
     */
    updateUploadStatusRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:updateUploadStatus`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given runId, update the upload status of the run.
     * @param {?} params The `RunDataUploadService.UpdateUploadStatusRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} The resources upload completed successfully.
     */
    updateUploadStatusRunDataV2(params) {
        return this.updateUploadStatusRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given run context ID, close an upload session.
     * @param {?} params The `RunDataUploadService.CloseUploadSessionRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload session is closed successfully
     */
    closeUploadSessionRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:closeUploadSession`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run context ID, close an upload session.
     * @param {?} params The `RunDataUploadService.CloseUploadSessionRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload session is closed successfully
     */
    closeUploadSessionRunDataV2(params) {
        return this.closeUploadSessionRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given run context ID, refresh and return the upload credentials.
     * @param {?} params The `RunDataUploadService.RefreshUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload is refreshed successfully
     */
    refreshUploadRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:refreshUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run context ID, refresh and return the upload credentials.
     * @param {?} params The `RunDataUploadService.RefreshUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Upload is refreshed successfully
     */
    refreshUploadRunDataV2(params) {
        return this.refreshUploadRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given run context ID, complete the upload stage and close the upload session if provided.
     * @param {?} params The `RunDataUploadService.CompleteUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Success
     */
    completeUploadRunDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/dataUpload/${params.runId}:completeUpload`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run context ID, complete the upload stage and close the upload session if provided.
     * @param {?} params The `RunDataUploadService.CompleteUploadRunDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Success
     */
    completeUploadRunDataV2(params) {
        return this.completeUploadRunDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
RunDataUploadService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: RunDataUploadService, factory: function RunDataUploadService_Factory(t) { return new (t || RunDataUploadService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(RunDataUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], canUploadRunDataV2Response: [], canUploadRunDataV2: [], connectivityCheckRunDataV2Response: [], connectivityCheckRunDataV2: [], startUploadRunDataV2Response: [], startUploadRunDataV2: [], getFileUploadPathRunDataV2Response: [], getFileUploadPathRunDataV2: [], directUploadInfoRunDataV2Response: [], directUploadInfoRunDataV2: [], updateUploadStatusRunDataV2Response: [], updateUploadStatusRunDataV2: [], closeUploadSessionRunDataV2Response: [], closeUploadSessionRunDataV2: [], refreshUploadRunDataV2Response: [], refreshUploadRunDataV2: [], completeUploadRunDataV2Response: [], completeUploadRunDataV2: [] });
RunDataUploadService.canUploadRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:canUpload';
RunDataUploadService.connectivityCheckRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:connectivityCheck';
RunDataUploadService.startUploadRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:startUpload';
RunDataUploadService.getFileUploadPathRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:getFileUploadPath';
RunDataUploadService.directUploadInfoRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}/directUploadInfo';
RunDataUploadService.updateUploadStatusRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:updateUploadStatus';
RunDataUploadService.closeUploadSessionRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:closeUploadSession';
RunDataUploadService.refreshUploadRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:refreshUpload';
RunDataUploadService.completeUploadRunDataV2Path = '/v2/infinium/runs/dataUpload/{runId}:completeUpload';
/** @nocollapse */
RunDataUploadService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ RunDataUploadService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RunDataUploadService_Factory() { return new RunDataUploadService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: RunDataUploadService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RunDataUploadService.canUploadRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.connectivityCheckRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.startUploadRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.getFileUploadPathRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.directUploadInfoRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.updateUploadStatusRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.closeUploadSessionRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.refreshUploadRunDataV2Path;
    /** @type {?} */
    RunDataUploadService.completeUploadRunDataV2Path;
}
(function (RunDataUploadService) {
    /**
     * Parameters for canUploadRunDataV2
     * @record
     */
    function CanUploadRunDataV2Params() { }
    RunDataUploadService.CanUploadRunDataV2Params = CanUploadRunDataV2Params;
    if (false) {
        /** @type {?} */
        CanUploadRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        CanUploadRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for connectivityCheckRunDataV2
     * @record
     */
    function ConnectivityCheckRunDataV2Params() { }
    RunDataUploadService.ConnectivityCheckRunDataV2Params = ConnectivityCheckRunDataV2Params;
    if (false) {
        /** @type {?} */
        ConnectivityCheckRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        ConnectivityCheckRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for startUploadRunDataV2
     * @record
     */
    function StartUploadRunDataV2Params() { }
    RunDataUploadService.StartUploadRunDataV2Params = StartUploadRunDataV2Params;
    if (false) {
        /** @type {?} */
        StartUploadRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        StartUploadRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for getFileUploadPathRunDataV2
     * @record
     */
    function GetFileUploadPathRunDataV2Params() { }
    RunDataUploadService.GetFileUploadPathRunDataV2Params = GetFileUploadPathRunDataV2Params;
    if (false) {
        /** @type {?} */
        GetFileUploadPathRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        GetFileUploadPathRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for directUploadInfoRunDataV2
     * @record
     */
    function DirectUploadInfoRunDataV2Params() { }
    RunDataUploadService.DirectUploadInfoRunDataV2Params = DirectUploadInfoRunDataV2Params;
    if (false) {
        /** @type {?} */
        DirectUploadInfoRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        DirectUploadInfoRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for updateUploadStatusRunDataV2
     * @record
     */
    function UpdateUploadStatusRunDataV2Params() { }
    RunDataUploadService.UpdateUploadStatusRunDataV2Params = UpdateUploadStatusRunDataV2Params;
    if (false) {
        /** @type {?} */
        UpdateUploadStatusRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        UpdateUploadStatusRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for closeUploadSessionRunDataV2
     * @record
     */
    function CloseUploadSessionRunDataV2Params() { }
    RunDataUploadService.CloseUploadSessionRunDataV2Params = CloseUploadSessionRunDataV2Params;
    if (false) {
        /** @type {?} */
        CloseUploadSessionRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        CloseUploadSessionRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for refreshUploadRunDataV2
     * @record
     */
    function RefreshUploadRunDataV2Params() { }
    RunDataUploadService.RefreshUploadRunDataV2Params = RefreshUploadRunDataV2Params;
    if (false) {
        /** @type {?} */
        RefreshUploadRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        RefreshUploadRunDataV2Params.prototype.body;
    }
    /**
     * Parameters for completeUploadRunDataV2
     * @record
     */
    function CompleteUploadRunDataV2Params() { }
    RunDataUploadService.CompleteUploadRunDataV2Params = CompleteUploadRunDataV2Params;
    if (false) {
        /** @type {?} */
        CompleteUploadRunDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        CompleteUploadRunDataV2Params.prototype.body;
    }
})(RunDataUploadService || (RunDataUploadService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/runs.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RunsService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of Runs accessible by the current JWT token
     * @param {?} params The `RunsService.ListRunsV2Params` containing the following parameters:
     *
     * - `uploadStatus`: UploadStatus for filtering results
     *
     * - `timeUploadStartedBefore`: Filter for runs with time upload started before this
     *
     * - `timeUploadStartedAfter`: Filter for runs with time upload started after this
     *
     * - `timeModifiedBefore`: Filter for runs with time modified before this
     *
     * - `timeModifiedAfter`: Filter for runs with time modified after this
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Product revision for filtering results
     *
     * - `productPartNumber`: Product part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `includeUploaded`: Flag to specify if we need the uploaded runs as well
     *
     * - `includeLatestOnly`: Flag to specify if we need only latest runs.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `aggregateStatus`: AggregateStatus for filtering results
     *
     * @return {?} Runs found and returned successfully.
     */
    listRunsV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.uploadStatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('uploadStatus', val.toString()); }));
        if (params.timeUploadStartedBefore != null)
            __params = __params.set('timeUploadStartedBefore', params.timeUploadStartedBefore.toString());
        if (params.timeUploadStartedAfter != null)
            __params = __params.set('timeUploadStartedAfter', params.timeUploadStartedAfter.toString());
        if (params.timeModifiedBefore != null)
            __params = __params.set('timeModifiedBefore', params.timeModifiedBefore.toString());
        if (params.timeModifiedAfter != null)
            __params = __params.set('timeModifiedAfter', params.timeModifiedAfter.toString());
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.productRevision != null)
            __params = __params.set('productRevision', params.productRevision.toString());
        if (params.productPartNumber != null)
            __params = __params.set('productPartNumber', params.productPartNumber.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.includeUploaded != null)
            __params = __params.set('includeUploaded', params.includeUploaded.toString());
        if (params.includeLatestOnly != null)
            __params = __params.set('includeLatestOnly', params.includeLatestOnly.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        (params.aggregateStatus || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('aggregateStatus', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of Runs accessible by the current JWT token
     * @param {?} params The `RunsService.ListRunsV2Params` containing the following parameters:
     *
     * - `uploadStatus`: UploadStatus for filtering results
     *
     * - `timeUploadStartedBefore`: Filter for runs with time upload started before this
     *
     * - `timeUploadStartedAfter`: Filter for runs with time upload started after this
     *
     * - `timeModifiedBefore`: Filter for runs with time modified before this
     *
     * - `timeModifiedAfter`: Filter for runs with time modified after this
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `productRevision`: Product revision for filtering results
     *
     * - `productPartNumber`: Product part number for filtering results
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `includeUploaded`: Flag to specify if we need the uploaded runs as well
     *
     * - `includeLatestOnly`: Flag to specify if we need only latest runs.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `aggregateStatus`: AggregateStatus for filtering results
     *
     * @return {?} Runs found and returned successfully.
     */
    listRunsV2(params) {
        return this.listRunsV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a new run
     * @param {?=} body undefined
     * @return {?} The Run is created successfully.
     */
    createRunV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a new run
     * @param {?=} body undefined
     * @return {?} The Run is created successfully.
     */
    createRunV2(body) {
        return this.createRunV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Run runId, returns information about that Run accessible by the current JWT token
     * @param {?} runId undefined
     * @return {?} Run resource with the given ID is found and its details returned successfully.
     */
    getRunV2Response(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/runs/${runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Run runId, returns information about that Run accessible by the current JWT token
     * @param {?} runId undefined
     * @return {?} Run resource with the given ID is found and its details returned successfully.
     */
    getRunV2(runId) {
        return this.getRunV2Response(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing run's metadata
     * @param {?} params The `RunsService.UpdateRunV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} The Run is updated successfully.
     */
    updateRunV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v2/infinium/runs/${params.runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing run's metadata
     * @param {?} params The `RunsService.UpdateRunV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} The Run is updated successfully.
     */
    updateRunV2(params) {
        return this.updateRunV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Run runId, disables that Run and deletes the data with the current JWT token
     * @param {?} runId undefined
     * @return {?} Run for the given ID is disabled successfully.
     */
    disableRunV2Response(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/runs/${runId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Run runId, disables that Run and deletes the data with the current JWT token
     * @param {?} runId undefined
     * @return {?} Run for the given ID is disabled successfully.
     */
    disableRunV2(runId) {
        return this.disableRunV2Response(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Start run verification
     * @param {?} runId undefined
     * @return {?} Verification is started successfully
     */
    startVerificationRunV2Response(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/${runId}:startVerification`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Start run verification
     * @param {?} runId undefined
     * @return {?} Verification is started successfully
     */
    startVerificationRunV2(runId) {
        return this.startVerificationRunV2Response(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update the status of the run
     * @param {?} params The `RunsService.UpdateRunStatusV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Status updated successfully
     */
    updateRunStatusV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/${params.runId}:updateStatus`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update the status of the run
     * @param {?} params The `RunsService.UpdateRunStatusV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Status updated successfully
     */
    updateRunStatusV2(params) {
        return this.updateRunStatusV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update the imaging data for the run
     * @param {?} params The `RunsService.UpdateRunImagingDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Imaging data updated successfully
     */
    updateRunImagingDataV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PUT', this.rootUrl + `/v2/infinium/runs/${params.runId}:updateImagingData`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update the imaging data for the run
     * @param {?} params The `RunsService.UpdateRunImagingDataV2Params` containing the following parameters:
     *
     * - `runId`:
     *
     * - `body`:
     *
     * @return {?} Imaging data updated successfully
     */
    updateRunImagingDataV2(params) {
        return this.updateRunImagingDataV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * For a given run ID, abort the run.
     * @param {?} runId undefined
     * @return {?} run aborted successfully.
     */
    abortRunV2Response(runId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs/${runId}:abort`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * For a given run ID, abort the run.
     * @param {?} runId undefined
     * @return {?} run aborted successfully.
     */
    abortRunV2(runId) {
        return this.abortRunV2Response(runId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Schedule batch deletion
     * @param {?=} body undefined
     * @return {?} Created
     */
    deleteV2RunBatchResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/runs:deleteBatch`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Schedule batch deletion
     * @param {?=} body undefined
     * @return {?} Created
     */
    deleteV2RunBatch(body) {
        return this.deleteV2RunBatchResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
RunsService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: RunsService, factory: function RunsService_Factory(t) { return new (t || RunsService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(RunsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listRunsV2Response: [], listRunsV2: [], createRunV2Response: [], createRunV2: [], getRunV2Response: [], getRunV2: [], updateRunV2Response: [], updateRunV2: [], disableRunV2Response: [], disableRunV2: [], startVerificationRunV2Response: [], startVerificationRunV2: [], updateRunStatusV2Response: [], updateRunStatusV2: [], updateRunImagingDataV2Response: [], updateRunImagingDataV2: [], abortRunV2Response: [], abortRunV2: [], deleteV2RunBatchResponse: [], deleteV2RunBatch: [] });
RunsService.listRunsV2Path = '/v2/infinium/runs';
RunsService.createRunV2Path = '/v2/infinium/runs';
RunsService.getRunV2Path = '/v2/infinium/runs/{runId}';
RunsService.updateRunV2Path = '/v2/infinium/runs/{runId}';
RunsService.disableRunV2Path = '/v2/infinium/runs/{runId}';
RunsService.startVerificationRunV2Path = '/v2/infinium/runs/{runId}:startVerification';
RunsService.updateRunStatusV2Path = '/v2/infinium/runs/{runId}:updateStatus';
RunsService.updateRunImagingDataV2Path = '/v2/infinium/runs/{runId}:updateImagingData';
RunsService.abortRunV2Path = '/v2/infinium/runs/{runId}:abort';
RunsService.deleteV2RunBatchPath = '/v2/infinium/runs:deleteBatch';
/** @nocollapse */
RunsService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ RunsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RunsService_Factory() { return new RunsService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: RunsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RunsService.listRunsV2Path;
    /** @type {?} */
    RunsService.createRunV2Path;
    /** @type {?} */
    RunsService.getRunV2Path;
    /** @type {?} */
    RunsService.updateRunV2Path;
    /** @type {?} */
    RunsService.disableRunV2Path;
    /** @type {?} */
    RunsService.startVerificationRunV2Path;
    /** @type {?} */
    RunsService.updateRunStatusV2Path;
    /** @type {?} */
    RunsService.updateRunImagingDataV2Path;
    /** @type {?} */
    RunsService.abortRunV2Path;
    /** @type {?} */
    RunsService.deleteV2RunBatchPath;
}
(function (RunsService) {
    /**
     * Parameters for listRunsV2
     * @record
     */
    function ListRunsV2Params() { }
    RunsService.ListRunsV2Params = ListRunsV2Params;
    if (false) {
        /**
         * UploadStatus for filtering results
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.uploadStatus;
        /**
         * Filter for runs with time upload started before this
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.timeUploadStartedBefore;
        /**
         * Filter for runs with time upload started after this
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.timeUploadStartedAfter;
        /**
         * Filter for runs with time modified before this
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.timeModifiedBefore;
        /**
         * Filter for runs with time modified after this
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.timeModifiedAfter;
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.sort;
        /**
         * Product revision for filtering results
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.productRevision;
        /**
         * Product part number for filtering results
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.productPartNumber;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.pageSize;
        /**
         * Flag to specify if we need the uploaded runs as well
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.includeUploaded;
        /**
         * Flag to specify if we need only latest runs.
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.includeLatestOnly;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.include;
        /**
         * AggregateStatus for filtering results
         * @type {?|undefined}
         */
        ListRunsV2Params.prototype.aggregateStatus;
    }
    /**
     * Parameters for updateRunV2
     * @record
     */
    function UpdateRunV2Params() { }
    RunsService.UpdateRunV2Params = UpdateRunV2Params;
    if (false) {
        /** @type {?} */
        UpdateRunV2Params.prototype.runId;
        /** @type {?|undefined} */
        UpdateRunV2Params.prototype.body;
    }
    /**
     * Parameters for updateRunStatusV2
     * @record
     */
    function UpdateRunStatusV2Params() { }
    RunsService.UpdateRunStatusV2Params = UpdateRunStatusV2Params;
    if (false) {
        /** @type {?} */
        UpdateRunStatusV2Params.prototype.runId;
        /** @type {?|undefined} */
        UpdateRunStatusV2Params.prototype.body;
    }
    /**
     * Parameters for updateRunImagingDataV2
     * @record
     */
    function UpdateRunImagingDataV2Params() { }
    RunsService.UpdateRunImagingDataV2Params = UpdateRunImagingDataV2Params;
    if (false) {
        /** @type {?} */
        UpdateRunImagingDataV2Params.prototype.runId;
        /** @type {?|undefined} */
        UpdateRunImagingDataV2Params.prototype.body;
    }
})(RunsService || (RunsService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/samples.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SamplesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of Samples accessible by the current JWT token
     * @param {?} params The `SamplesService.ListSamplesV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `beadChipName`: Beadchip Name for filtering results. Result items must match the provided beadchip name.
     *
     * - `beadChipAndSampleSectionNames`: List of BeadChipAndSampleSection Names with comma-separated "{beadChipName}_{sampleSectionName}" such as "204619760001_R01C01"
     *
     * @return {?} Samples found and returned successfully.
     */
    listSamplesV2Response(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.sort != null)
            __params = __params.set('sort', params.sort.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        (params.include || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('include', val.toString()); }));
        if (params.beadChipName != null)
            __params = __params.set('beadChipName', params.beadChipName.toString());
        (params.beadChipAndSampleSectionNames || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('beadChipAndSampleSectionNames', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/samples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of Samples accessible by the current JWT token
     * @param {?} params The `SamplesService.ListSamplesV2Params` containing the following parameters:
     *
     * - `sort`: Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
     *
     * - `pageToken`: Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
     *
     * - `pageSize`: Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
     *
     * - `include`: Include flags to specify what is included in the response
     *
     * - `beadChipName`: Beadchip Name for filtering results. Result items must match the provided beadchip name.
     *
     * - `beadChipAndSampleSectionNames`: List of BeadChipAndSampleSection Names with comma-separated "{beadChipName}_{sampleSectionName}" such as "204619760001_R01C01"
     *
     * @return {?} Samples found and returned successfully.
     */
    listSamplesV2(params) {
        return this.listSamplesV2Response(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create new samples
     * @param {?=} body undefined
     * @return {?} The Samples are created successfully.
     */
    createSamplesV2Response(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/samples`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create new samples
     * @param {?=} body undefined
     * @return {?} The Samples are created successfully.
     */
    createSamplesV2(body) {
        return this.createSamplesV2Response(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Sample sampleId, returns information about that Sample accessible by the current JWT token.
     * @param {?} sampleId undefined
     * @return {?} Sample resource with the given ID is found and its details returned successfully.
     */
    getSampleV2Response(sampleId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v2/infinium/samples/${sampleId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Sample sampleId, returns information about that Sample accessible by the current JWT token.
     * @param {?} sampleId undefined
     * @return {?} Sample resource with the given ID is found and its details returned successfully.
     */
    getSampleV2(sampleId) {
        return this.getSampleV2Response(sampleId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a Sample sampleId, disables that Sample with the current JWT token.
     * @param {?} sampleId undefined
     * @return {?} Sample for the given ID is disabled successfully.
     */
    disableSampleV2Response(sampleId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v2/infinium/samples/${sampleId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a Sample sampleId, disables that Sample with the current JWT token.
     * @param {?} sampleId undefined
     * @return {?} Sample for the given ID is disabled successfully.
     */
    disableSampleV2(sampleId) {
        return this.disableSampleV2Response(sampleId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Schedule data deletion
     * @param {?=} body undefined
     * @return {?} Created
     */
    deleteV2DataBySampleSheetResponse(body) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v2/infinium/samples:deleteData`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Schedule data deletion
     * @param {?=} body undefined
     * @return {?} Created
     */
    deleteV2DataBySampleSheet(body) {
        return this.deleteV2DataBySampleSheetResponse(body).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
SamplesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: SamplesService, factory: function SamplesService_Factory(t) { return new (t || SamplesService)(ɵngcc0.ɵɵinject(GmsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SamplesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GmsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listSamplesV2Response: [], listSamplesV2: [], createSamplesV2Response: [], createSamplesV2: [], getSampleV2Response: [], getSampleV2: [], disableSampleV2Response: [], disableSampleV2: [], deleteV2DataBySampleSheetResponse: [], deleteV2DataBySampleSheet: [] });
SamplesService.listSamplesV2Path = '/v2/infinium/samples';
SamplesService.createSamplesV2Path = '/v2/infinium/samples';
SamplesService.getSampleV2Path = '/v2/infinium/samples/{sampleId}';
SamplesService.disableSampleV2Path = '/v2/infinium/samples/{sampleId}';
SamplesService.deleteV2DataBySampleSheetPath = '/v2/infinium/samples:deleteData';
/** @nocollapse */
SamplesService.ctorParameters = () => [
    { type: GmsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ SamplesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SamplesService_Factory() { return new SamplesService(ɵɵinject(GmsApiConfiguration), ɵɵinject(HttpClient)); }, token: SamplesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SamplesService.listSamplesV2Path;
    /** @type {?} */
    SamplesService.createSamplesV2Path;
    /** @type {?} */
    SamplesService.getSampleV2Path;
    /** @type {?} */
    SamplesService.disableSampleV2Path;
    /** @type {?} */
    SamplesService.deleteV2DataBySampleSheetPath;
}
(function (SamplesService) {
    /**
     * Parameters for listSamplesV2
     * @record
     */
    function ListSamplesV2Params() { }
    SamplesService.ListSamplesV2Params = ListSamplesV2Params;
    if (false) {
        /**
         * Specifies the order to include list items as "_{fieldName}_ [asc|desc]". The second field is optional and specifies the sort direction ("asc" for ascending or "desc" for descending).
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.sort;
        /**
         * Page offset descriptor. Valid page tokens are included in the response. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.pageToken;
        /**
         * Number of items to include in a page. Value must be an integer between 1 and 1000. Only one of pageSize or pageToken can be specified.
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.pageSize;
        /**
         * Include flags to specify what is included in the response
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.include;
        /**
         * Beadchip Name for filtering results. Result items must match the provided beadchip name.
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.beadChipName;
        /**
         * List of BeadChipAndSampleSection Names with comma-separated "{beadChipName}_{sampleSectionName}" such as "204619760001_R01C01"
         * @type {?|undefined}
         */
        ListSamplesV2Params.prototype.beadChipAndSampleSectionNames;
    }
})(SamplesService || (SamplesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/gms-api.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Provider for all GmsApi services, plus GmsApiConfiguration
 */
class GmsApiModule {
    /**
     * @param {?} customParams
     * @return {?}
     */
    static forRoot(customParams) {
        return {
            ngModule: GmsApiModule,
            providers: [
                {
                    provide: GmsApiConfiguration,
                    useValue: { rootUrl: customParams.rootUrl }
                }
            ]
        };
    }
}
GmsApiModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: GmsApiModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(GmsApiModule, { imports: function () { return [HttpClientModule]; }, exports: function () { return [HttpClientModule]; } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GmsApiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                exports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    GmsApiConfiguration,
                    AnalysisconfigurationsService,
                    AnalysisdefinitionsService,
                    AnalysisfilesService,
                    AnalysisrunsService,
                    AnalysisversiondefinitionsService,
                    BeadchipsService,
                    IdatsUploadService,
                    ManifestsService,
                    ProductsService,
                    RunDataUploadService,
                    RunsService,
                    SamplesService
                ]
            }]
    }], null, null);
GmsApiModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function GmsApiModule_Factory(t) { return new (t || GmsApiModule)(); }, providers: [
        GmsApiConfiguration,
        AnalysisconfigurationsService,
        AnalysisdefinitionsService,
        AnalysisfilesService,
        AnalysisrunsService,
        AnalysisversiondefinitionsService,
        BeadchipsService,
        IdatsUploadService,
        ManifestsService,
        ProductsService,
        RunDataUploadService,
        RunsService,
        SamplesService
    ], imports: [[
            HttpClientModule
        ],
        HttpClientModule] });

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: stratus-gms-v2-ng-sdk.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AggregateRunStatus, AnalysisConfigurationSortFields, AnalysisDefinitionSortFields, AnalysisFileSortFields, AnalysisRunSortFields, AnalysisVersionDefinitionSortFields, AnalysisconfigurationsService, AnalysisdefinitionsService, AnalysisfilesService, AnalysisrunsService, AnalysisversiondefinitionsService, BaseService, BeadChipSortFields, BeadchipsService, GmsApiModule, IdatsUploadService, ListAnalysisConfigurationsIncludeFlags, ListAnalysisDefinitionsIncludeFlags, ListAnalysisFilesIncludeFlags, ListAnalysisRunIncludeFlags, ListAnalysisVersionDefinitionsIncludeFlags, ListBeadChipsIncludeFlags, ListManifestsIncludeFlags, ListProductsIncludeFlags, ListRunsIncludeFlags, ListSamplesIncludeFlags, ManifestSortFields, ManifestsService, ProductSortFields, ProductsService, RunDataUploadService, RunSortFields, RunStageProgress, RunUploadStatus, RunsService, SampleSectionDataStatus, SampleSortFields, SamplesService, SortDirection, GmsApiConfiguration as ɵa };

//# sourceMappingURL=stratus-gms-v2-ng-sdk.js.map